import { WarningIcon } from "@/components/icons";
import { Flex, Text } from "@chakra-ui/react";
import { useMemo } from "react";

const ErrorText = ({ error }: { error: string }) => {
  const showDepoit = useMemo(() => {
    return error.includes("Insufficient");
  }, [error]);

  return (
    <Flex
      sx={{
        position: "fixed",
        bottom: "100px",
        left: "0",
        width: "100%",
        textAlign: "center",
        padding: "12px",
        background: "#F13434",
        color: "#FFF",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "12px",
        zIndex: 1000,
      }}
      flexDir={"column"}
      align={"center"}
      justify={"center"}
    >
      <Flex align={"center"}>
        <WarningIcon
          style={{
            width: "11px",
            marginRight: "2px",
          }}
        ></WarningIcon>
        <Text sx={{}}>{error}</Text>
      </Flex>
      {showDepoit && <Text>Please deposit more tokens</Text>}
    </Flex>
  );
};

export default ErrorText;
